import { createRoot } from "react-dom/client";

import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import App from "App";
import { BASE_PATH } from "config";
import { store } from "store";
import reportWebVitals from "reportWebVitals";
import { ConfigProvider } from "hooks/contexts/ConfigContext";
import "assets/scss/style.scss";
import "material-icons/iconfont/material-icons.css";
import React, { Suspense } from "react";
import { Loader } from "./components/Loader/Loader";

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <Suspense fallback={<Loader />}>
      <ConfigProvider>
        <BrowserRouter basename={BASE_PATH}>
          <App />
        </BrowserRouter>
      </ConfigProvider>
    </Suspense>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
